import { boolean, type InferOutput, number, object, optional } from 'valibot'

import {
  createSorterSchema,
  TRUCK_MODELS_SORT_KEYS
} from '@/features/shared/models'

export const TruckModelsSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(TRUCK_MODELS_SORT_KEYS),
  dcId: optional(number()), // DC ID
  enable: optional(boolean()) // 有効/無効
})

export type TruckModelsSearch = InferOutput<typeof TruckModelsSearchSchema>
